module.exports = __webpack_public_path__ + "img/SALE.fc62aebd.svg";